import usePageMeta from "../../seo/usePageMeta";

export default function CatalogPage({
  title,
  description,
  path,
  noindex,
  eyebrow,
  h1,
  children,
}) {
  return (
    <div className="bg-white text-gray-900">
      {usePageMeta({ title, description, path, noindex })}
      <section className="bg-gray-950 px-4 py-14 text-white sm:px-6 sm:py-16">
        <div className="mx-auto max-w-6xl">
          {eyebrow ? <p className="mb-3 text-sm text-white/70">{eyebrow}</p> : null}
          <h1 className="text-3xl font-bold tracking-tight sm:text-5xl">{h1}</h1>
        </div>
      </section>
      <div className="mx-auto max-w-6xl px-4 py-10 sm:px-6 sm:py-12">{children}</div>
    </div>
  );
}
